// extracted by mini-css-extract-plugin
export default {"unlimited-payments":"unlimited-payments_unlimited-payments__D7CuE"};